import { render, staticRenderFns } from "./CyberRiskAwareLicenceModal.vue?vue&type=template&id=6e9ba968&"
import script from "./CyberRiskAwareLicenceModal.vue?vue&type=script&lang=js&"
export * from "./CyberRiskAwareLicenceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports